module.exports = __webpack_public_path__ + "static/media/solar_state_diagram_start.5a32613e.jpg";